var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#7236CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 11.3125L12 13.375L17.5 7.875M17.5 12V16.125C17.5 16.4897 17.3551 16.8394 17.0973 17.0973C16.8394 17.3551 16.4897 17.5 16.125 17.5H7.875C7.51033 17.5 7.16059 17.3551 6.90273 17.0973C6.64487 16.8394 6.5 16.4897 6.5 16.125V7.875C6.5 7.51033 6.64487 7.16059 6.90273 6.90273C7.16059 6.64487 7.51033 6.5 7.875 6.5H14.0625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMark);
export default __webpack_public_path__ + "static/media/squareMark.8c85180e6828f74ece64413473bf8824.svg";
export { ForwardRef as ReactComponent };